import React, {Component} from 'react'
import { Redirect, Link } from "react-router-dom"

class Unsellable extends Component {

	constructor(props) {
		super(props)
        this.state = {
        }        
	}

    
	render() {
		return (
			<div className="modal">
                <h3>Home Unsellable</h3>
                <p>Currently pending sale.  Please cancel or close the existing sale and try again.</p>
                <ul className="modal__buttonList">
                    <li className="error"><Link to="/entry/cancels/new-cancel">Cancel Sale</Link></li>
                    <li><Link to="/entry/closings/new-closing">Close Sale</Link></li>
                </ul>
            </div>
		)
	}
}

export default Unsellable
